<lib-checkbox [checked]="bindingProperty" (checkedChange)="dataChanged($event)"></lib-checkbox>
